import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../../config/payrollApiConfig';

// Create
export const createPfWithdrawal = createAsyncThunk(
    'pfWithdrawal/create',
    async (data: any, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            for (const key in data) {
                if (data[key] !== undefined && data[key] !== null) {
                    if (key === 'attachment' && data[key] instanceof File) {
                        formData.append('attachment', data[key], data[key].name);
                    } else {
                        formData.append(key, data[key]);
                    }
                }
            }
            const res = await payrollServiceApiInstance.post('/pf-withdrawal', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            return res.data;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || 'Failed to create PF withdrawal request');
        }
    }
);

// Get All
export const fetchAllPfWithdrawals = createAsyncThunk(
    'pfWithdrawal/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const res = await payrollServiceApiInstance.get('/pf-withdrawal');
            return res.data;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || 'Failed to fetch PF withdrawal requests');
        }
    }
);

// Get By ID
export const fetchPfWithdrawalById = createAsyncThunk(
    'pfWithdrawal/fetchById',
    async (id: number, { rejectWithValue }) => {
        try {
            const res = await payrollServiceApiInstance.get(`/pf-withdrawal/${id}`);
            return res.data;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || 'Failed to fetch PF withdrawal request');
        }
    }
);

// Update
export const updatePfWithdrawal = createAsyncThunk(
    'pfWithdrawal/update',
    async ({ id, data }: { id: number; data: any }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            for (const key in data) {
                if (data[key] !== undefined && data[key] !== null) {
                    if (key === 'attachment' && data[key] instanceof File) {
                        formData.append('attachment', data[key], data[key].name);
                    } else {
                        formData.append(key, data[key]);
                    }
                }
            }
            const res = await payrollServiceApiInstance.put(`/pf-withdrawal/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return { id, data: res.data };
        } catch (err: any) {
            return rejectWithValue(err.response?.data || 'Failed to update PF withdrawal request');
        }
    }
);

// Delete
export const deletePfWithdrawal = createAsyncThunk(
    'pfWithdrawal/delete',
    async (id: number, { rejectWithValue }) => {
        try {
            await payrollServiceApiInstance.delete(`/pf-withdrawal/${id}`);
            return id;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || 'Failed to delete PF withdrawal request');
        }
    }
);
